// src/components/SearchWidget.jsx
// Accommodation + Cruises tabs — no flights, no airports
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SearchWidget.css";
import { suggestDestinations, localSuggestions, correctDestination } from "../services/hotelApi";

const TODAY    = new Date();
const fmt      = d => d.toISOString().split("T")[0];
const addD     = (d,n) => { const x=new Date(d); x.setDate(x.getDate()+n); return x; };
const fmtShort = d => {
  if (!d) return "";
  try { return new Date(d).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}); }
  catch { return d; }
};

const DESTS = [
  "Antalya","Tenerife","Majorca","Lanzarote","Gran Canaria","Fuerteventura",
  "Ibiza","Corfu","Rhodes","Zante","Cyprus","Algarve","Maldives","Dubai",
  "Phuket","Bali","Barcelona","Paris","Rome","Lisbon","Cancun","Marrakech",
  "Malta","Crete","Mykonos","Santorini","Kos","Menorca","Benidorm",
  "Hurghada","Sharm El Sheikh","Bodrum","Dalaman","Paphos","Faro","Madeira",
  "Agadir","Costa Brava","Costa del Sol","Costa Blanca","Egypt","Morocco","Turkey","Greece",
];

const TYPE_LABEL = { city:"City", region:"Region", country:"Country", district:"Area" };

const FLEX = [
  {v:"0",l:"Not flexible"},
  {v:"1",l:"± 1 day"},
  {v:"2",l:"± 2 days"},
  {v:"3",l:"± 3 days"},
  {v:"7",l:"± 1 week"},
];

const IC = {
  Pin:   ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  Cal:   ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Moon:  ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  Users: ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Sliders:({s=14,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>,
  Search:({s=16,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Globe: ({s=17,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  Check: ({s=13,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  ChevD: ({s=11,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
  ChevL: ({s=13,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  ChevR: ({s=13,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>,
  X:     ({s=11,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.8" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Hotel: ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 22V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14"/><path d="M3 22h18"/><path d="M9 22V12h6v10"/></svg>,
  Ship:  ({s=15,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 20a2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1"/><path d="M4 17h16"/><path d="M6 10V3h12v7"/><path d="M12 10v7"/></svg>,
  Info:  ({s=12,c="currentColor"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  Phone: ({s=15,c="#fff"}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  WA:    ({s=15}) => <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/></svg>,
};

function useClickOutside(ref, cb) {
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) cb(); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [cb]);
}

// ── Destination Field ──────────────────────────────────────
// Works for any city, region/zone, area or country. Live suggestions
// come from Booking.com; typos are corrected ("costa barva" → Costa Brava).
function DestField({ value, onChange, onPick }) {
  const [open, setOpen]       = useState(false);
  const [live, setLive]       = useState([]);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, useCallback(() => setOpen(false), []));

  // Debounced live lookup
  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 2) { setLive([]); setLoading(false); return; }
    let gone = false;
    setLoading(true);
    const t = setTimeout(() => {
      suggestDestinations(q)
        .then(r => { if (!gone) setLive(r); })
        .catch(() => { if (!gone) setLive([]); })
        .finally(() => { if (!gone) setLoading(false); });
    }, 300);
    return () => { gone = true; clearTimeout(t); };
  }, [value]);

  const q        = (value || "").trim();
  const quick    = q ? localSuggestions(q, 6) : DESTS.slice(0, 10);
  const liveKeys = new Set(live.map(l => l.name.toLowerCase()));
  const quickOnly = quick.filter(n => !liveKeys.has(n.toLowerCase()));
  const fix      = q ? correctDestination(q) : null;
  const didYouMean = fix && fix.toLowerCase() !== q.toLowerCase()
    && !quick.some(n => n.toLowerCase() === q.toLowerCase()) ? fix : null;

  const pickText = name => { onChange(name); onPick && onPick(null); setOpen(false); };
  const pickLive = s => { onChange(s.name); onPick && onPick(s); setOpen(false); };

  return (
    <div className="sw-field sw-f-dest" ref={ref}>
      <div className="sw-label">Destination</div>
      <div className={`sw-box${open ? " sw-box-focus" : ""}`}>
        <span className="sw-ico"><IC.Pin s={15}/></span>
        <input
          className="sw-inp"
          placeholder="City, region, country — e.g. Agadir, Costa Brava, Egypt"
          value={value || ""}
          onChange={e => { onChange(e.target.value); onPick && onPick(null); setOpen(true); }}
          onFocus={() => setOpen(true)}
          autoComplete="off"
        />
        {value && (
          <button className="sw-clear-btn" type="button" onClick={() => { onChange(""); onPick && onPick(null); }}>
            <IC.X s={10}/>
          </button>
        )}
      </div>
      {open && (
        <div className="sw-drop" style={{ zIndex:1300, maxHeight:380, overflowY:"auto" }}>
          <div
            className={`sw-drop-row sw-drop-any${!value ? " sw-drop-active" : ""}`}
            onMouseDown={() => pickText("")}
          >
            <IC.Globe s={16} c="#16a34a"/>
            <div>
              <div className="sw-drop-main">Any destination</div>
              <div className="sw-drop-sub">Show best hotel deals across all destinations</div>
            </div>
          </div>

          {didYouMean && (
            <div className="sw-drop-row" onMouseDown={() => pickText(didYouMean)}>
              <IC.Search s={13} c="#e8390e"/>
              <span>Did you mean <b>{didYouMean}</b>?</span>
            </div>
          )}

          {live.map(s => (
            <div key={`${s.dest_id}|${s.search_type}`}
              className={`sw-drop-row${value === s.name ? " sw-drop-active" : ""}`}
              onMouseDown={() => pickLive(s)}>
              <IC.Pin s={13} c="#16a34a"/>
              <div style={{ minWidth:0 }}>
                <div className="sw-drop-main">{s.name}</div>
                <div className="sw-drop-sub">
                  {TYPE_LABEL[s.type] || "Place"}
                  {s.label && s.label !== s.name ? ` · ${s.label}` : ""}
                  {s.hotels ? ` · ${s.hotels.toLocaleString()} hotels` : ""}
                </div>
              </div>
            </div>
          ))}

          {quickOnly.map(d => (
            <div key={d} className={`sw-drop-row${value === d ? " sw-drop-active" : ""}`}
              onMouseDown={() => pickText(d)}>
              <IC.Pin s={13} c="#94a3b8"/>
              <span>{d}</span>
            </div>
          ))}

          {loading && q.length >= 2 && (
            <div className="sw-drop-row" style={{ cursor:"default" }}>
              <span className="sw-drop-sub">Finding places…</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── Date Field ─────────────────────────────────────────────
function DateField({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [month, setMonth] = useState(() => {
    const d = value ? new Date(value) : addD(TODAY, 14);
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const ref = useRef(null);
  useClickOutside(ref, useCallback(() => setOpen(false), []));
  const todStr   = fmt(TODAY);
  const dInMo    = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const startDow = (new Date(month.getFullYear(), month.getMonth(), 1).getDay() + 6) % 7;

  return (
    <div className="sw-field sw-f-date" ref={ref}>
      <div className="sw-label">Check-in Date</div>
      <div className={`sw-box sw-box-click${open ? " sw-box-focus" : ""}`} onClick={() => setOpen(o => !o)}>
        <span className="sw-ico"><IC.Cal s={15}/></span>
        <span className={`sw-val${!value ? " sw-val-ph" : ""}`}>
          {value ? fmtShort(value) : "Select date"}
        </span>
        {value
          ? <button className="sw-clear-btn" type="button" onClick={e => { e.stopPropagation(); onChange(""); }}><IC.X s={10}/></button>
          : <span className="sw-chev"><IC.ChevD s={11}/></span>
        }
      </div>
      {open && (
        <div className="sw-drop sw-cal-drop" style={{ zIndex:1300 }}>
          <div className="sw-cal-head">
            <button type="button" className="sw-cal-nav" onClick={() => setMonth(m => new Date(m.getFullYear(), m.getMonth() - 1, 1))}><IC.ChevL s={13} c="#64748b"/></button>
            <span className="sw-cal-mth">{month.toLocaleDateString("en-GB",{month:"long",year:"numeric"})}</span>
            <button type="button" className="sw-cal-nav" onClick={() => setMonth(m => new Date(m.getFullYear(), m.getMonth() + 1, 1))}><IC.ChevR s={13} c="#64748b"/></button>
          </div>
          <div className="sw-cal-body">
            <div className="sw-cal-dow">{["Mo","Tu","We","Th","Fr","Sa","Su"].map(d => <div key={d} className="sw-cal-dh">{d}</div>)}</div>
            <div className="sw-cal-grid">
              {[...Array(startDow)].map((_,i) => <div key={`g${i}`}/>)}
              {[...Array(dInMo)].map((_,i) => {
                const day = i+1;
                const iso = fmt(new Date(month.getFullYear(), month.getMonth(), day));
                const past = iso < todStr, sel = iso === value, tod = iso === todStr;
                return (
                  <button key={day} type="button" disabled={past}
                    className={`sw-cal-day${sel?" sw-cal-sel":""}${tod&&!sel?" sw-cal-today":""}`}
                    onMouseDown={() => { if(!past){onChange(iso);setOpen(false);} }}>
                    {day}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="sw-cal-foot">
            <button type="button" className="sw-cal-clear" onClick={() => { onChange(""); setOpen(false); }}>Clear date</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Flexibility Field ──────────────────────────────────────
function FlexField({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, useCallback(() => setOpen(false), []));
  const label = FLEX.find(f => f.v === value)?.l || "Not flexible";

  return (
    <div className="sw-field sw-f-flex" ref={ref}>
      <div className="sw-label">Flexibility</div>
      <div className={`sw-box sw-box-click${open ? " sw-box-focus" : ""}`} onClick={() => setOpen(o => !o)}>
        <span className="sw-ico"><IC.Sliders s={14}/></span>
        <span className="sw-val">{label}</span>
        <span className="sw-chev"><IC.ChevD s={11}/></span>
      </div>
      {open && (
        <div className="sw-drop sw-sm-drop" style={{ zIndex:1300 }}>
          {FLEX.map(f => (
            <div key={f.v} className={`sw-drop-row${f.v===value?" sw-drop-active":""}`}
              onMouseDown={() => { onChange(f.v); setOpen(false); }}>
              <span style={{width:18,display:"flex",alignItems:"center",flexShrink:0}}>
                {f.v===value && <IC.Check s={12} c="#1e40af"/>}
              </span>
              {f.l}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Nights Field ───────────────────────────────────────────
function NightsField({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, useCallback(() => setOpen(false), []));

  return (
    <div className="sw-field sw-f-nights" ref={ref}>
      <div className="sw-label">Duration</div>
      <div className={`sw-box sw-box-click${open ? " sw-box-focus" : ""}`} onClick={() => setOpen(o => !o)}>
        <span className="sw-ico"><IC.Moon s={14}/></span>
        <span className="sw-val">{value} night{value !== 1 ? "s" : ""}</span>
        <span className="sw-chev"><IC.ChevD s={11}/></span>
      </div>
      {open && (
        <div className="sw-drop sw-sm-drop" style={{ zIndex:1300 }}>
          {[3,4,5,6,7,8,9,10,11,12,13,14,17,21,28].map(n => (
            <div key={n} className={`sw-drop-row${n===value?" sw-drop-active":""}`}
              onMouseDown={() => { onChange(n); setOpen(false); }}>
              <span style={{width:18,display:"flex",alignItems:"center",flexShrink:0}}>
                {n===value && <IC.Check s={12} c="#1e40af"/>}
              </span>
              {n} night{n !== 1 ? "s" : ""}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Rooms/Guests Field ─────────────────────────────────────
function RoomsField({ rooms, adults, children, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, useCallback(() => setOpen(false), []));

  const bump = (field, dir) => {
    const v = { rooms, adults, children };
    const mins = { rooms:1, adults:1, children:0 };
    const maxs = { rooms:8, adults:12, children:10 };
    v[field] = Math.min(maxs[field], Math.max(mins[field], v[field] + dir));
    onChange(v);
  };
  const summary = `${rooms} Room${rooms!==1?"s":""} · ${adults} Adult${adults!==1?"s":""}${children>0?` · ${children} Child${children!==1?"ren":""}` : ""}`;

  return (
    <div className="sw-field sw-f-rooms" ref={ref}>
      <div className="sw-label">Guests</div>
      <div className={`sw-box sw-box-click${open ? " sw-box-focus" : ""}`} onClick={() => setOpen(o => !o)}>
        <span className="sw-ico"><IC.Users s={15}/></span>
        <span className="sw-val" style={{fontSize:13}}>{summary}</span>
        <span className="sw-chev"><IC.ChevD s={11}/></span>
      </div>
      {open && (
        <div className="sw-drop sw-rooms-drop" style={{ zIndex:1300 }}>
          {[
            ["rooms","Rooms","",1,8],
            ["adults","Adults","Age 18+",1,12],
            ["children","Children","Age 0–17",0,10],
          ].map(([field, label, sub, min, max]) => {
            const curr = field==="rooms"?rooms:field==="adults"?adults:children;
            return (
              <div key={field} className="sw-rooms-row">
                <div><div className="sw-rl">{label}</div>{sub&&<div className="sw-rs">{sub}</div>}</div>
                <div className="sw-ctr">
                  <button type="button" className="sw-cb" onClick={() => bump(field,-1)} disabled={curr<=min}>−</button>
                  <span className="sw-cn">{curr}</span>
                  <button type="button" className="sw-cb" onClick={() => bump(field,+1)} disabled={curr>=max}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Cruises CTA ────────────────────────────────────────────
function CruisesCTA() {
  return (
    <div style={{padding:"30px 20px",textAlign:"center",background:"linear-gradient(135deg,#f0f7ff,#e8f4fd)",border:"1px solid #bfdbfe",borderTop:"none",borderRadius:"0 0 10px 10px"}}>
      <div style={{fontSize:40,marginBottom:10}}>🚢</div>
      <h3 style={{fontFamily:"'Plus Jakarta Sans',sans-serif",fontWeight:900,color:"#0B1F3A",fontSize:16,margin:"0 0 6px"}}>Cruise Holidays</h3>
      <p style={{fontSize:13,color:"#475569",fontFamily:"'DM Sans',sans-serif",margin:"0 0 18px",maxWidth:420,marginLeft:"auto",marginRight:"auto"}}>
        We offer worldwide cruise holidays. Contact our specialists for tailored Hotels deals and exclusive offers.
      </p>
      <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
        <a href="tel:02030190055"
          style={{display:"inline-flex",alignItems:"center",gap:7,padding:"11px 20px",background:"#0B1F3A",color:"#fff",borderRadius:9,fontWeight:700,fontSize:13,textDecoration:"none",fontFamily:"'DM Sans',sans-serif"}}>
          <IC.Phone s={13}/> 020 3019 0055
        </a>
        <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer"
          style={{display:"inline-flex",alignItems:"center",gap:7,padding:"11px 20px",background:"#22c55e",color:"#fff",borderRadius:9,fontWeight:700,fontSize:13,textDecoration:"none",fontFamily:"'DM Sans',sans-serif"}}>
          <IC.WA s={13}/> WhatsApp Us
        </a>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// MAIN WIDGET
// ══════════════════════════════════════════════════════════
export default function SearchWidget({ defaultTab = "hotel", compact = false }) {
  const navigate = useNavigate();
  const [sp]     = useSearchParams();

  // Always default to hotel (never "package" since we removed that tab)
  const initTab  = defaultTab === "cruises" ? "cruises" : "hotel";
  const [tab,    setTab]    = useState(initTab);
  const [dest,   setDest]   = useState(sp.get("city") || "");
  // Exact Booking.com place chosen from the suggestions (null = free text)
  const [picked, setPicked] = useState(() =>
    sp.get("dest_id") && sp.get("dest_type")
      ? { dest_id: sp.get("dest_id"), search_type: sp.get("dest_type"), name: sp.get("city") || "" }
      : null);
  const [date,   setDate]   = useState(sp.get("checkIn") || fmt(addD(TODAY, 30)));
  const [flex,   setFlex]   = useState("0");
  const [nights, setNights] = useState(7);
  const [guests, setGuests] = useState({
    rooms:    Number(sp.get("rooms")  || 1),
    adults:   Number(sp.get("guests") || 2),
    children: 0,
  });

  const doSearch = e => {
    if (e?.preventDefault) e.preventDefault();
    if (tab === "cruises") return;
    const ci = date || fmt(addD(TODAY, 30));
    const co = fmt(addD(new Date(ci), nights));
    const p  = new URLSearchParams({
      city:        dest.trim() || "",
      checkIn:     ci,
      checkOut:    co,
      guests:      String(guests.adults),
      children:    String(guests.children),
      rooms:       String(guests.rooms),
      mode:        "hotel",
      flexibility: flex,
    });
    if (picked && dest.trim() && picked.name === dest.trim()) {
      p.set("dest_id",   String(picked.dest_id));
      p.set("dest_type", String(picked.search_type));
    }
    navigate(`/hotels?${p}`);
  };

  const infoMsg = () => {
    if (!dest.trim()) return "No destination selected — we'll show the best hotel deals across all destinations";
    return `Searching hotels in ${dest}`;
  };

  return (
    <div className="sw-root">
      {/* Tabs — only shown in non-compact mode */}
      {!compact && (
        <div className="sw-tabs">
          {[
            { id:"hotel",   label:"Accommodation", Icon:IC.Hotel },
            { id:"cruises", label:"Cruises",        Icon:IC.Ship  },
          ].map(t => (
            <button
              key={t.id}
              type="button"
              className={`sw-tab${tab===t.id?" sw-tab-on":""}`}
              onClick={() => setTab(t.id)}
            >
              <t.Icon s={14} c={tab===t.id ? "#1a2744" : "#8896a6"}/>
              {t.label}
            </button>
          ))}
        </div>
      )}

      {/* Cruises = call us panel; Hotel = search form */}
      {tab === "cruises" && !compact ? (
        <CruisesCTA/>
      ) : (
        <form className="sw-form" onSubmit={doSearch}>
          <DestField  value={dest}   onChange={setDest} onPick={setPicked}/>
          <DateField  value={date}   onChange={setDate}/>
          <FlexField  value={flex}   onChange={setFlex}/>
          <NightsField value={nights} onChange={setNights}/>
          <RoomsField
            rooms={guests.rooms}
            adults={guests.adults}
            children={guests.children}
            onChange={setGuests}
          />
          <div className="sw-btn-col">
            {!compact && <div className="sw-label">&nbsp;</div>}
            <button type="submit" className="sw-search-btn">
              <IC.Search s={16} c="#fff"/>
              Search
            </button>
          </div>
        </form>
      )}

      {/* Info strip */}
      {!compact && tab !== "cruises" && (
        <div className="sw-strip">
          <IC.Info s={12} c="#e8390e"/>
          {infoMsg()}
        </div>
      )}
    </div>
  );
}